import { IncentivesTable } from "./IncentivesTable";

export function IncentivesPage() {
  return <IncentivesTable />;
}
